import styled from "styled-components";

export const HeaderTabela = styled.div`
width: 100%;
display: flex;
flex-direction: column;
`